const ExpenseCategories: React.FC = () => {
  return <div>Expense Categories</div>
}

export default ExpenseCategories
